<template>
  <div class="profile-dropdown col nav-item dropdown navbar-dropdown" v-dropdown>
    <a class="nav-link dropdown-toggle" href="">
      <span class="profile-section-avatar-container">
        <slot></slot>
      </span>
    </a>
    <div class="dropdown-menu last">
      <div class="dropdown-menu-content">
        <div
          v-for="(option, id) in options" 
          :key="id"
          class="dropdown-item plain-link-item"
          @click.prevent="onClick(option.name)"
        >
          <a class="plain-link">{{ `user.${option.name}` | translate}}</a>
        </div>
      </div>
    </div>

    <vuestic-modal 
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      :cancelClass="'none'"
      :okText="'modal.confirm' | translate"
      :cancelText="'modal.cancel' | translate"
      @ok="signOut()"
    >
      <div slot="title">{{'modal.confirmTitle' | translate}}</div>
      <div>{{'modal.confirmQuitMessage' | translate}}</div>
    </vuestic-modal>
  </div>
</template>

<script>
  export default {
    name: 'profile-section',

    data () {
      return {
        show: true
      }
    },

    props: {
      options: {
        type: Array,
        default: () => [
          {
            name: 'profile'
          },
          {
            name: 'logout'
          }
        ]
      }
    },

    methods: {
      onClick (name) {
        switch (name) {
          case 'profile':
            break
          case 'logout':
            this.$refs.smallModal.open()
            break
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../../sass/variables";

  .profile-dropdown {

    .profile-section-avatar-container {
      display: inline-block;
      width: 50px;
      height: 50px;
      background-color: white;
      border-radius: 50%;
      border: 2px solid $lighter-gray;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/components/dropdowns/ProfileDropdown.vue